import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { homeStyles } from '../../Styles/homeStyles';
import { inject, observer } from 'mobx-react';
import { ReactSVG } from 'react-svg'
import Images from '../../Theme/Images';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import CircularProgress from '@material-ui/core/CircularProgress';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import FiberManualRecordOutlinedIcon from '@material-ui/icons/FiberManualRecordOutlined';
import SearchQuery from './SearchQuery';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import { withRouter } from 'react-router-dom';
//import Carousel from 'react-material-ui-carousel'
import LatestTicket from './LatestTicket';
import Slider from 'infinite-react-carousel';
import MenuIcon from '@material-ui/icons/Menu';
import LoginDrawer from './LoginDrawer';
import PendingChat from './PendingChat';

@inject('queryStore', 'commonStore', 'userStore')
@observer
class Home extends Component {
    state = {
        showLoder: true,
        openOptions: false
    }

    closeOptions = () => {
        this.setState({ openOptions: false })
    }

    componentDidMount() {
        this.props.queryStore.getFaqs()
        let that = this;
        setTimeout(that.showInitialLoader, 100);
    }

    showInitialLoader = () => {
        this.setState({ showLoder: false })
    }


    askQuery = (item) => {
        this.props.userStore.resetAnonymousId()
        if (item.type === 'CHAT_INTENT') {
            this.props.history.push({
                pathname: '/chat',
                state: {
                    queryText: item.text,
                    type: item.type,
                    slug: item.slug
                }
            })
        }
        else {
            let temp = [{ intent: item.type, filter: "HEALTH_POLICY" }]
            if (this.props.userStore.authenticated) {
                this.props.queryStore.askQuery(temp, null)
                    .then(() => {
                        if (!this.props.queryStore.inProgress) {
                            if (this.props.queryStore.policyList && this.props.queryStore.policyList.length) {
                                this.props.history.push({
                                    pathname: '/policies',
                                    state: { input: [{ intent: item.type, filter: "HEALTH_POLICY" }] }
                                })
                            }
                            else if (this.props.queryStore.redirectToChat) {
                                this.props.history.push('/chat')
                            }
                            else {
                                this.props.commonStore.setHeaderText('Pending Queries')
                                this.props.history.push({
                                    pathname: '/queries/pending',
                                    state: { type: "pending" }
                                })
                            }
                        }
                    })
            }
            else
                this.props.history.push({
                    pathname: '/login',
                    state: { type: 'pending', createQuery: temp }
                })
        }

    }

    renderLoader = () => {
        const { classes } = this.props;
        return (
            <div className={classes.outerLoader}>
                <CircularProgress size={50} thickness={2} className={classes.progress} />
            </div>
        )
    }

    renderFAQList = () => {
        const { classes } = this.props;
        const { faqs } = this.props.queryStore;
        return (
            faqs.map((item, index) => (
                <ListItem classes={{ divider: item.icon === 'card_icon' ? classes.firstItem : classes.lineDivider }} button key={item.text} divider={true} onClick={(event) => this.askQuery(item)}>
                    {<ListItemIcon style={{ minWidth: '2vw' }}>
                        <ReactSVG
                            beforeInjection={svg => {
                                svg.classList.add(classes.icons)
                            }}
                            src={Images[`${item.icon}`]} />
                    </ListItemIcon>}
                    <div className={classes.listItems}>

                        {
                            item.icon === 'card_icon' ?
                                <div className={classes.categoryContainer}>
                                    <div className={classes.categoryText}>{item.text}</div>
                                </div>
                                :
                                <div className={classes.categoryContainer}>
                                    <div className={classes.categoryText}>{item.text}</div>
                                </div>
                        }

                        <ListItemSecondaryAction>
                            <ReactSVG src={Images.forwardIcon} style={{ cursor: 'pointer' }} />
                        </ListItemSecondaryAction>
                    </div>
                </ListItem>
            ))
        )
    }

    openPreferences = () => {
        this.props.history.push({
            pathname: '/preferences'
        })
    }

    onLoginClick = () => {
        this.props.userStore.resetStatusText()
        this.props.history.push('/login')
    }

    initiateChat = () => {
        this.props.userStore.resetAnonymousId()
        this.props.history.push('/chat')
    }

    render() {
        const { classes } = this.props;
        const { inProgress, faqs, pendingList } = this.props.queryStore;
        const { openOptions } = this.state;
        const { authenticated } = this.props.userStore;
        const { showSearchOnly } = this.props.commonStore
        if (inProgress)
            this.renderLoader()
        return (
            <div className={classes.homeContainer}>
                {!showSearchOnly ? <div>
                    {pendingList && pendingList.length && !this.state.showLoder ?
                        <Slider dots={false} autoplay={false} autoplayScroll={1} arrows={false}>
                            {
                                pendingList.map((item, index) => <LatestTicket item={item} index={index} />)
                            }
                        </Slider> : null}
                    <PendingChat />
                    <div>
                        {faqs ?
                            <List>
                                {this.renderFAQList()}
                                {
                                    authenticated ? null :
                                        <ListItem classes={{ divider: classes.lineDivider }} button divider={true} onClick={(e) => this.onLoginClick()}>
                                            <ListItemIcon style={{ minWidth: '2vw' }}>
                                                <ReactSVG
                                                    beforeInjection={svg => {
                                                        svg.classList.add(classes.icons)
                                                    }}
                                                    src={Images.login} />
                                            </ListItemIcon>
                                            <div className={classes.listItems}>
                                                <span>Login </span>
                                                <ListItemSecondaryAction>
                                                    <ArrowForwardIosIcon style={{ cursor: 'pointer' }} className={classes.rightChevron}></ArrowForwardIosIcon>

                                                </ListItemSecondaryAction>
                                            </div>
                                        </ListItem>
                                }
                                <ListItem classes={{ divider: classes.lineDivider }} button divider={true} onClick={(e) => this.initiateChat()}>
                                    <ListItemIcon style={{ minWidth: '2vw' }}>
                                        <ReactSVG
                                            beforeInjection={svg => {
                                                svg.classList.add(classes.icons)
                                            }}
                                            src={Images.chatIcon} />
                                    </ListItemIcon>
                                    <div className={classes.listItems}>
                                        <span>Initiate Chat</span>
                                        <ListItemSecondaryAction>
                                            <ArrowForwardIosIcon style={{ cursor: 'pointer' }} className={classes.rightChevron}></ArrowForwardIosIcon>

                                        </ListItemSecondaryAction>
                                    </div>
                                </ListItem>
                            </List>
                            : null}</div>
                </div> : null}
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    <div className={classes.bottomContainer}>
                        <div className={classes.menuContainer}>
                            <MenuIcon className={classes.menuIcon} onClick={(e) => this.setState({ openOptions: true })} />
                        </div>
                        <SearchQuery></SearchQuery>
                        <LoginDrawer open={openOptions} closeLogin={this.closeOptions} />
                    </div>
                </div>
            </div>
        )
    }
}
Home.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withRouter((withStyles(homeStyles)(Home)))
